import { IGlobalState } from '@/store';
import { isNationIncluded } from '@repo/utils';
import {
  IMG_BADGE_AIRPLANE,
  IMG_BADGE_CARD,
  IMG_BADGE_MONEY,
  IMG_BADGE_CASH,
  IMG_BADGE_CASH_PICKUP,
  IMG_BADGE_DOC_SEARCH,
  IMG_TRANSFER_BADGE,
  IMG_TRANSFER,
} from '@repo/assets';
import IMG_FILE from '@/assets/korUploadFile/img_file.png';
import styled from 'styled-components';
import { format } from 'date-fns';
import IMG_UPLOAD_FILE from '@/assets/korUploadFile/img_file.png';
import {
  getRefundType,
  MAIN_NATIONS,
  VAN_REFUNDABLE_AIRPORT_CODE_LIST,
} from '@repo/constants';
import ICON_CHECK_FILE from '@/assets/uploadFile/icon_check_file.png';

export const getMedicalStatusData = ({
  // TODO - 출국장소, 환급일 데이터를 받아야 한다.
  nationality,
  paymentStatus,
  isRefundInfoRegistered,
  departureProgress,
  refundedIn,
  refundedDate,
  isCashPickup,
  isUploadRequired,
}: Partial<IGlobalState>) => {
  let title, description, actionBtnLabel, image, warning;

  const getCurrentStep = () => {
    if (refundedIn && VAN_REFUNDABLE_AIRPORT_CODE_LIST.includes(refundedIn)) {
      return 7;
    }
    if (paymentStatus === 'PAYMENT_COMPLETE' && isRefundInfoRegistered) {
      return 3;
    }
    if (!isRefundInfoRegistered) {
      return 1;
    }
    if (!isUploadRequired && nationality !== 'KOR') {
      return 2;
    }
    switch (departureProgress) {
      case 'DEPARTURE_CHECK_COMPLETE':
        return 2;
      case 'TICKET_CHECK_IN_PROGRESS':
        return 5;
      case 'TICKET_RE_UPLOAD':
        return 6;
      default:
        return 4;
    }
  };

  const currentStep = getCurrentStep();
  switch (currentStep) {
    case 1:
      if (nationality === 'KOR') {
        title = '계좌 정보가 필요해요!';
        description = '환급금을 받을 계좌 정보를 3개월 이내에\n입력해주세요.';
        actionBtnLabel = '송금 정보 입력하러 가기';
      } else if (isCashPickup) {
        title = 'Enter your information for\nWestern Union cash pickup';
        description =
          'Please enter your personal information to receive cash via Western Union based on your passport nationality.';
      } else {
        title = 'Enter the information.';
        description = (
          <p>
            You must enter the information
            <br />
            <span style={{ color: '#1856CD' }}>within 3 months</span> for the
            procedure
            <br />
            to receive a refund.
          </p>
        );
        actionBtnLabel = 'Enter the information';
      }
      image = IMG_BADGE_CARD;
      break;
    case 2:
      if (nationality === 'KOR') {
        title = '소중한 환급액을 송금 중입니다!';
        description = '세관 확인 후 송금까지 영업일 기준\n21일 정도 소요됩니다';
        actionBtnLabel = '송금 정보 다시 한번 더 확인하기';
      } else if (isCashPickup) {
        title = 'Your information\nis being verified';
        description = (
          <>
            After your information and departure are verified, your refund will
            be ready for cash pickup at Western Union{' '}
            <Strong>within 21 days</Strong>
          </>
        );
        image = IMG_BADGE_DOC_SEARCH;
        actionBtnLabel = undefined;
      } else if (isUploadRequired) {
        title = 'Your refund is being processed.';
        description =
          'After Customs verification, the refund transfer typically takes about 21 business days.';
        actionBtnLabel = undefined;
        image = IMG_TRANSFER;
      } else {
        title = `Transferring your refund`;
        description = nationality
          ? isNationIncluded(MAIN_NATIONS, nationality)
            ? `Refund will be completed about\n21 business days.`
            : 'The transfer will take about 21 days\nafter entering your account information\non email.'
          : '';
        actionBtnLabel = 'Double check my account information';
        image = IMG_BADGE_MONEY;
      }
      break;
    case 3:
      if (nationality === 'KOR') {
        title = '환급금을 송금했어요!';
        description = `즐거운 여행이 되셨기를 바랍니다`;
        actionBtnLabel = undefined;
        image = IMG_BADGE_AIRPLANE;
      } else if (isCashPickup) {
        title = 'You can now receive\nyour cash';
        description = (
          <>
            Visit a Western Union location
            <br />
            <Strong>based on your passport nationality within 3 months of your departure</Strong>, show the MTCN
            below, and pick up your refund.
          </>
        );
        actionBtnLabel = undefined;
        image = IMG_BADGE_CASH_PICKUP;
      } else {
        title = `Your refund has been completed.`;
        description = `Please check your bank account.`;
        actionBtnLabel = undefined;
        image = IMG_BADGE_MONEY;
      }
      break;
    case 4:
      if (nationality !== 'KOR') {
        title = 'Upload the files';
        description =
          'Upload the documents needed for entry and departure verification.';
        actionBtnLabel = 'Upload files';
        image = IMG_UPLOAD_FILE;
        break;
      }
      title = '출입국사실증명서 업로드';
      description = `출국 이후 출입국사실증명서를\n다운로드 후 파일을 업로드해주세요.`;
      warning = '(출입국 사실증명은 출국 1주일 후 반영됩니다.)';
      image = IMG_UPLOAD_FILE;
      break;
    case 5:
      if (nationality !== 'KOR') {
        title = 'Checking Files';
        description =
          'Verification may take up to 21 days, and the transfer will be processed once completed.';
        warning =
          'If there is an error in the file, a re-upload will be requested.';
        image = ICON_CHECK_FILE;
        break;
      }
      title = '출입국사실증명서를\n확인중입니다.';
      description =
        '확인까지 영업일 기준 최대 5일 정도\n소요되며 완료 후 환급이 진행됩니다.';
      warning = '(필요시 재업로드를 요청할 수 있습니다.)';
      image = IMG_FILE;
      break;
    case 6:
      if (nationality !== 'KOR') {
        title = 'Checking Files';
        description =
          'Verification may take up to 21 days, and the transfer will be processed once completed.';
        warning =
          'If there is an error in the file, a re-upload will be requested.';
        image = ICON_CHECK_FILE;
        break;
      }
      title = '출입국사실증명 자료를\n재업로드 해주세요.';
      description = '발급 방법을 참고하여 재업로드 해주세요.';
      image = IMG_FILE;
      break;
    case 7:
      // TODO - VAN환급 케이스 추가
      if (nationality === 'KOR') {
        title = '환급 완료되었어요!';
        description = (
          <dl>
            <div style={{ marginBottom: '10px' }}>
              <DataTitle>환급장소</DataTitle>
              <DataValue>
                {refundedIn && getRefundType(nationality, refundedIn)}
              </DataValue>
            </div>
            <div>
              <DataTitle>환급일시</DataTitle>
              <DataValue>
                {refundedDate &&
                  format(new Date(refundedDate), 'yyyy-MM-dd HH:mm')}
              </DataValue>
            </div>
          </dl>
        );
      } else {
        title = `Refund Completed`;
        description = (
          <dl>
            <div style={{ marginBottom: '10px' }}>
              <DataTitle>Refund Place</DataTitle>
              <DataValue>
                {refundedIn && getRefundType(nationality, refundedIn)}
              </DataValue>
            </div>
            <div>
              <DataTitle>Refund Date</DataTitle>
              <DataValue>
                {refundedDate &&
                  format(new Date(refundedDate), 'yyyy-MM-dd HH:mm')}
              </DataValue>
            </div>
          </dl>
        );
      }
      image = IMG_BADGE_CASH;
      break;
  }
  return { title, description, actionBtnLabel, image, warning };
};

const DataTitle = styled.dt`
  color: #999;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const DataValue = styled.dd`
  color: #111;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const Contents = styled.p`
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const Strong = styled.strong`
  color: var(--KTP-Warning-100, #ed0828);
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;
